import React from 'react';

/**
 * Shared "Page X of Y (N total)" + Prev/Next bar for CI Admin directory
 * tables -- rendered both above and below the table on each page so the
 * count/controls are visible without scrolling, whichever end you land on.
 */
export default function CiPaginationBar({
  page,
  totalPages,
  total,
  loading,
  onPrevPage,
  onNextPage,
  label,
  prevLabel = 'Prev',
  nextLabel = 'Next',
  position = 'bottom',
}) {
  if (!total || total <= 0) return null;
  const borderClass = position === 'top' ? 'border-bottom' : 'border-top';
  return (
    <div className={`d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2 ${borderClass}`}>
      <span className="text-muted small">
        {label || `Page ${page + 1} of ${totalPages} (${total} total)`}
      </span>
      <div className="btn-group btn-group-sm">
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={loading || page <= 0}
          onClick={onPrevPage}
        >
          {prevLabel}
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={loading || page + 1 >= totalPages}
          onClick={onNextPage}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
}
